import { render, staticRenderFns } from "./ShortSummary.vue?vue&type=template&id=7d7505c2&scoped=true&"
import script from "./ShortSummary.vue?vue&type=script&lang=js&"
export * from "./ShortSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShortSummary.vue?vue&type=style&index=0&id=7d7505c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7505c2",
  null
  
)

export default component.exports